import { TableTab } from 'coreOld/elements';
import { ITab } from 'coreOld/types';

import { Wrapper } from './tabsStyle';

interface IProps {
  tabs: ITab[];
  activeTab: ITab;
  onClick: (tab: ITab) => void;
}

const TabsNavigation = ({ tabs, onClick, activeTab }: IProps) => {
  return (
    <Wrapper>
      {tabs.map((tab, index) => (
        <TableTab
          key={index}
          icon={tab.icon}
          title={tab.title}
          isSelected={activeTab.title === tab.title}
          onClick={() => onClick(tab)}
        />
      ))}
    </Wrapper>
  );
};

export default TabsNavigation;
